import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import Pusher, { Channel } from 'pusher-js';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SseService {
  private pusher?: Pusher;
  private channel?: Channel;

  private currentUserId?: number;

  constructor(private authService: AuthService) {}

  connect(userId: number) {
    if (
      this.pusher &&
      this.currentUserId === userId &&
      this.pusher.connection.state === 'connected'
    ) {
      return;
    }

    this.currentUserId = userId;

    this.disconnect();

    this.pusher = new Pusher(environment.auth_socket_key, {
      cluster: environment.auth_socket_cluster,
      wsHost: environment.auth_socket_reverb_host,
      forceTLS: environment.auth_socket_reverb_scheme === 'https',
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      channelAuthorization: {
        customHandler: async ({ socketId, channelName }, callback) => {
          try {
            const r = await this.__api('/ws/auth', {
              socket_id: socketId,
              channel_name: channelName,
            });
            if (r.ok && r.json?.auth) {
              callback(null, r.json);
              return;
            }

            if (r.status === HttpStatusCode.Unauthorized) {
              this.authService.insertPinRequired$.next('login');
            }
            callback(new Error(`auth gagal (${r.status})`), null);
          } catch (error) {
            callback(error as HttpErrorResponse, null);
          }
        },
      },
    });

    // Semua event masuk, supaya nama event aslinya kelihatan.
    // this.pusher.connection.bind_global(console.log);

    this.pusher.connection.bind('connected', () => {
      if (this.channel?.subscribed) return;
      const channelName = `private-user.${userId}`;
      this.channel = this.pusher!.subscribe(channelName);

      this.channel.bind('pusher:subscription_succeeded', () => {});
      this.channel.bind('pusher:subscription_error', () => {});
      this.channel.bind('SessionStateChanged', (event: { type: string }) => {
        const eventType = event.type ?? '';
        switch (eventType) {
          case 'pin_required':
            this.authService.insertPinRequired$.next('refresh');
            this.disconnect();
            break;
          case 'refresh_token_required':
            this.authService.refresh();
            this.disconnect();
            break;
        }
      });

      // Semua event masuk, supaya nama event aslinya kelihatan.
      // this.channel.bind_global(console.log);
    });

    this.pusher.connection.bind('error', console.error);
  }

  disconnect() {
    this.pusher?.disconnect();
    this.pusher = undefined;
    this.channel = undefined;
    // this.currentUserId = undefined;
  }

  // async watch() {
  //   const res = await this.__api('/ws/watch');
  //   if (res.json) {
  //     const msg = res.json.state?.message || res.json.message;
  //     switch (msg) {
  //       case 'pin_required':
  //         this.authService.insertPinRequired$.next('refresh');
  //         this.disconnect();
  //         break;
  //       case 'refresh_token_required':
  //         this.authService.refresh((userId: number) => {
  //           this.connect(userId);
  //         });
  //         this.disconnect();
  //         break;
  //     }
  //   }
  // }

  private async __api(path: string, body: Record<string, unknown> = {}) {
    const response = await fetch(`${environment.auth_socket_url}${path}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body && { body: JSON.stringify(body) }),
    });

    let json = null;
    json = await response.json();

    return { ok: response.ok, status: response.status, json };
  }
}
